module.exports = __webpack_public_path__ + "img/t21e.d038e4bd.png";